<template>
    <img :src="$page.props.logo_full">
</template>
